import { render, staticRenderFns } from "./ResetPasswordRecovery.vue?vue&type=template&id=1ef85e9b&lang=pug&"
import script from "./ResetPasswordRecovery.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordRecovery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports